
import { Component, Vue } from "vue-property-decorator";
import { Validations } from "vuelidate-property-decorators";
import { required, numeric } from "vuelidate/lib/validators";

@Component
export default class MixinMaxOrderAmountForDeferredPaymentEditorValidator extends Vue {
  @Validations()
  validations = {
    item: {
      //NP後払い上限金額
      maxOrderAmountForDeferredPayment: { required, numeric },
    },
  };
  //---------------------------
  // methods
  //---------------------------

  /**
   * NP後払い上限金額入力エラーメッセージを返します.
   */
  get maxOrderAmountForDeferredPaymentErrors(): string[] {
    const errors: string[] = [];
    if (!this.$v.item.maxOrderAmountForDeferredPayment?.$dirty) return errors;
    !this.$v.item.maxOrderAmountForDeferredPayment?.required &&
      errors.push("NP後払い上限金額を入力してください.");
    !this.$v.item.maxOrderAmountForDeferredPayment?.numeric &&
      errors.push("数値を入力してください.");
    return errors;
  }
}
